const home = {
  state: 'Hello from store.',
};

export default home;
